import { Route } from "components/utils";
import { Dashboard as LogisticsDashboard } from "pages/logistics/dashboard/Dashboard";
import { NotFound } from "pages/notFound";
import { RouteComponentProps, Switch } from "react-router-dom";

export const Dashboard = ({ match }: RouteComponentProps): JSX.Element => {
  return (
    <Switch>
      <Route
        component={LogisticsDashboard}
        exact={true}
        path={`${match.path}`}
        title="Milo - logistyka"
      />
      <Route component={NotFound} exact={true} path="*" title="Milo" />
    </Switch>
  );
};
